import { ModalAction } from './modal.action'
import { ModalConfig } from './modal-config'
// @Injectable()
export abstract class EuModalService {

    // _modal_context: {
    //     vcRef: ViewContainerRef
    //     componentFactoryResolver: ComponentFactoryResolver
    // }

    _default_actions: Array<ModalAction>

    _confirm_actions: Array<ModalAction>

    _smodalstack = []
    // _ref:ComponentRef<SimpleModalComponent>
    constructor() {

    }

    abstract openConfirm(
        modalOptions: ModalConfig,
        success?: Function, dismiss?: Function,
        // modalContext?: {
        //     vcRef: ViewContainerRef
        //     componentFactoryResolver: ComponentFactoryResolver
        // }
    ): any

    abstract open(
        modalOptions: ModalConfig,
        success?: Function, dismiss?: Function,
        // modalContext?: {
        //     vcRef: ViewContainerRef
        //     componentFactoryResolver: ComponentFactoryResolver
        // }
    ): any

    abstract destroy(): any
}